import React, { useState, useEffect, useRef } from "react";

import cx from 'classnames';
import _ from 'lodash';

import styles from '../leadReports.module.scss';

export function PageInteractionsHeader() {
  return (
    <div className={cx(styles.pageReportHeaderContainer)}>
      <div className={styles.header}>
        <span className={cx(styles.name, styles.pageNameColumn)}>Page Name</span>
        <span className={cx(styles.name, styles.viewsColumn)}>Views</span>
        <span className={cx(styles.name, styles.timeSpentColumn)}>Total Time</span>
        <span className={cx(styles.name, styles.bounceRateColumn)}>% Completed</span>
      </div>
    </div>
  )
}

export function AssetInteractionsHeader() {
  return (
    <div className={cx(styles.assetReportHeaderContainer)}>
      <div className={styles.header}>
        <span className={cx(styles.name, styles.assetColumn)}>Asset Name</span>
        <span className={cx(styles.name, styles.viewsColumn)}>Views</span>
        <span className={cx(styles.name, styles.avgTimeSpentColumn)}>Time Spent</span>
        <span className={cx(styles.name, styles.bounceColumn)}>% Completed</span>
        <span className={cx(styles.name, styles.downloadColumn)}>Downloads</span>
      </div>
    </div>
  )
}

export function LeadsAnalyticsHeader() {
  return (
    <div className={cx(styles.leadsAnalyticsHeaderContainer)}>
      <div className={styles.header}>
        <span className={cx(styles.name, styles.leadColumn)}>Lead & Account</span>
        <span className={cx(styles.name, styles.campaignColumn)}>Source</span>
        <span className={cx(styles.name, styles.sourceColumn)}>Campaign</span>
        <span className={cx(styles.name, styles.createdDateColumn)}>Created Date</span>
        <span className={cx(styles.name, styles.lastVisitedColumn)}>Last Visited</span>
        <span className={cx(styles.name, styles.viewsColumn)}>Views</span>
        <span className={cx(styles.name, styles.timeSpentColumn)}>Time Spent</span>
        <span className={cx(styles.name, styles.completionColumn)}>Completion %</span>
      </div>
    </div>
  )
}


export function TableInfo(props) {
  return (
    <div className={styles.tableInfo} >
      <div className={styles.tableTitle}>{props.name}
        <span className={styles.count}>({_.get(props.pagination, 'totalRecordsCount', 0)})</span>
      </div>
    </div>
  )
}

export function EmptyMessage({ videoId }) {
  const ref = useRef(null);

  const emptyMessages = [
    {
      video: "/images/telescopeEmptyMessage.mp4",
      content: <span>No sightings to report.<br />Swing by this telescope later?</span>
    },
    {
      video: "/images/sateliteEmptyMessage.mp4",
      content: <span>No song’s coming off<br />this blank space though</span>
    },
  ];

  const [emptyMessageContent, setEmptyMessageContent] = useState({})

  useEffect(() => {
    ref.current.play();
    getRandomValueFromArray(emptyMessages)
  }, []);

  const getRandomValueFromArray = (array) => {
    var value = array[Math.floor(Math.random() * array.length)];
    setEmptyMessageContent(value)
  }

  return (
    <div className={styles.emptyMessage}>
      <div className={cx(styles.loaderContainer)}>
        <div className={styles.loaderVideoWrapper}>
          <video ref={ref} className={styles.loaderMessageVideo} loop autoPlay={true} playsInline muted>
            <source src={emptyMessageContent.video} type="video/mp4" />
          </video>
          <label className={styles.loaderMessage}>{emptyMessageContent.content}</label>
        </div>
      </div>
    </div>
  )
}

export const renderInitials = (name) => {
  let firstName = _.get(name, 'firstName') || '';
  let lastName = _.get(name, 'lastName') || '';

  let initial = '';

  if (firstName) {
    initial = firstName.charAt(0);
  }

  if (lastName) {
    initial = initial + lastName.charAt(0);
  }

  return initial.toUpperCase();
}

export function LoadingMessage() {
  const ref = useRef(null);

  useEffect(() => {
    ref.current.play();
  }, []);

  const loadingMessages = [
    <span>Getting you the Sun,<br /> Moon, and Stars</span>,
    <span>Rummaging through the lunar <br /> craters to find your numbers</span>
  ];

  return (
    <div className={styles.emptyMessage}>
      <div className={cx(styles.loaderContainer)}>
        <div className={styles.loaderVideoWrapper}>
          <video ref={ref} className={styles.loaderMessageVideo} loop autoPlay={true} playsInline muted>
            <source src="/images/reportsLoader.mp4" type="video/mp4" />
          </video>
          <label className={styles.loaderMessage}>{loadingMessages[Math.floor(Math.random() * loadingMessages.length)]}</label>
        </div>
      </div>
    </div>
  )
}

export function getWidthForAnalyticsBar(data) {
  var width = 18;

  if (data.length > 1) {
    width = 30;
  }

  if (data.length > 5) {
    width = 50;
  }

  if (data.length > 10) {
    width = 100;
  }

  return width;
}
